import React from "react";

function Complete({ width = 20, height = 20, fill = "#513E3E" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 10.8335C16.4167 10.8335 16.975 10.9418 17.5 11.1252V10.0002L16.6667 5.8335H3.33333L2.5 10.0002V11.6668H3.33333V16.6668H10.9083C10.8667 16.3918 10.8333 16.1168 10.8333 15.8335C10.8333 14.8085 11.1417 13.8668 11.6667 13.0752V11.6668H13.075C13.8667 11.1418 14.8083 10.8335 15.8333 10.8335ZM10 15.0002H5V11.6668H10V15.0002ZM4.2 10.0002L4.7 7.50016H15.3L15.8 10.0002H4.2ZM16.6667 5.00016H3.33333V3.3335H16.6667V5.00016ZM18.75 14.3752L14.7917 18.3335L12.5 15.8335L13.4667 14.8668L14.7917 16.1918L17.7833 13.2002L18.75 14.3752Z"
        fill={fill}
      />
    </svg>
  );
}

export default Complete;
